
class Name {
  constructor(id, label, index = 0, value=undefined) {
    this.id = id;
    this.label = label;
    this.index = index;
    this.value = value;
  }

  getSplitName = () => {
    return this.id.split("|")[1];
  }
}

export { Name };